import { Navigate, Outlet } from "react-router-dom";
import { Scale } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-[#FBF6F4]"
        data-testid="auth-loading"
      >
        <Scale className="h-6 w-6 animate-pulse text-slate-400" strokeWidth={1.5} />
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
